<div class="w-full p-6">
  <div class="max-h-[80vh] overflow-y-auto pr-2">
    <h3 class="titre3">{{ 'USERS_MANAGEMENT.CREATE_SSO_ADMIN_PILOT_TITLE' | translate }}</h3>

    <div class="mb-4 mt-4">
      <span class="block text-sm font-medium mb-2">{{ 'USERS_MANAGEMENT.ROLES' | translate }}</span>
      <div class="flex flex-col space-y-2">
        @if (estPiloteGroupe) {
          <div class="flex items-center">
            <input type="checkbox" id="estInvitePilote" (change)="onChangementRole('pilote')"
              class="form-checkbox h-5 w-5 border-gray-300 rounded mr-2 focus:outline-none focus:ring-0"
              [(ngModel)]="estInvitePilote">
              <label for="estInvitePilote">{{ 'USERS_MANAGEMENT.PILOT' | translate }}</label>
            </div>
          }

          <div class="flex items-center">
            <input type="checkbox" id="estInviteAdmin" (change)="onChangementRole('admin')"
              class="form-checkbox h-5 w-5 border-gray-300 rounded mr-2 focus:outline-none focus:ring-0"
              [(ngModel)]="estInviteAdmin">
              <label for="estInviteAdmin">{{ 'USERS_MANAGEMENT.ADMINISTRATOR' | translate }}</label>
            </div>

            @if (estInviteAdmin && entites.length > 1) {
              <div class="ml-6 mt-2">
                @if (entitesDispoInviteAdmin.length > 0) {
                  <select title="entite"
                    [(ngModel)]="entiteIdInviteAdminSelectionnee" (change)="onEntiteAdminSelectionnee($event)"
                    class="w-full p-2 border rounded">
                    <option [ngValue]="null" hidden>{{ 'USERS_MANAGEMENT.SELECT_COMPANY' | translate }}</option>
                    @for (entite of entitesDispoInviteAdmin; track entite) {
                      <option [value]="entite.id">{{ entite.nom }}
                      </option>
                    }
                  </select>
                }
                @if (inviteEntiteAdmins.length > 0) {
                  <div class="mt-3">
                    <div class="titre4Modal">{{ 'USERS_MANAGEMENT.SELECTED_ENTITIES' | translate }}:</div>
                    <ul class="list-disc list-inside">
                      @for (entite of inviteEntiteAdmins; track entite) {
                        <li class="text-gray-600">
                          {{ entite.nom }}
                          <button (click)="supprimerEntiteSelectionnee(entite.id)" class="ml-2 text-rougeNovo">
                            {{ 'USERS_MANAGEMENT.REMOVE' | translate }}
                          </button>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
            @if (estInviteAdmin && entites.length === 1) {
              <div class="ml-6 mt-2">
                <span class="text-sm font-semibold">{{entites[0].nom}}</span>
              </div>
            }
          </div>
        </div>

        <div class="mb-4 mt-2">
          <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.VIEWING_ENTITY' | translate }}</span>
          @if (entiteUnique) {
            <div>
              <span class="text-sm font-semibold">{{entiteUnique.nom}}</span>
            </div>
          } @else {
            <select title="entite" id="selecteur-entite" [(ngModel)]="entiteVisioSelectionnee"
              (change)="onEntiteVisioSelectionnee($event)" class="w-full p-2 border rounded">
              @for (entite of entites; track entite) {
                <option [value]="entite.id">{{entite.nom}}</option>
              }
            </select>
          }
        </div>

        <div class="mb-4 mt-2">
          <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.TAGS' | translate }}</span>
          <select #etiquetteSelect title="TAGS" id="etiquettes"
            (change)="onEtiquetteSelectionnee($event, etiquetteSelect)" class="w-full p-2 border rounded">
            <option value="">{{ 'USERS_MANAGEMENT.SELECT_TAG' | translate }}</option>
            @for (etiquette of etiquettesDisponibles; track etiquette) {
              <option [value]="etiquette.etiquetteId">
                {{ etiquetteService.getNomLocalise(etiquette.locales) }}
              </option>
            }
          </select>

          @if (etiquettesSelectionnees.length > 0) {
            <div class="mt-3">
              <div class="titre4Modal">{{ 'USERS_MANAGEMENT.SELECTED_TAGS' | translate }}:</div>
              <ul class="list-disc list-inside">
                @for (etiquette of etiquettesSelectionnees; track etiquette) {
                  <li>
                    {{ etiquetteService.getNomLocalise(etiquette.locales) }}
                    <button (click)="supprimerEtiquetteSelectionnee(etiquette.etiquetteId)"
                      class="ml-2 text-rougeNovo">
                      {{ 'USERS_MANAGEMENT.REMOVE' | translate }}
                    </button>
                  </li>
                }
              </ul>
            </div>
          }
        </div>

        <div class="mb-4">
          <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.CREATION_METHOD' | translate }}</span>
          <select id="selecteur-methode-creation" [(ngModel)]="methodeCreation" class="w-full p-2 border rounded">
            <option value="manual">{{ 'USERS_MANAGEMENT.MANUAL_ADDITION' | translate }}</option>
            <option value="excel">{{ 'USERS_MANAGEMENT.IMPORT_FROM_EXCEL' | translate }}</option>
          </select>
        </div>

        @if (methodeCreation === 'excel') {
          <div class="mb-6">
            <div class="mb-4">
              <button class="px-4 py-2 btn-primary-novo" (click)="telechargerModeleExcel()">{{
              'USERS_MANAGEMENT.DOWNLOAD_EXCEL_TEMPLATE' | translate }}</button>
            </div>
            <div class="mb-4">
              <input type="file" (change)="onFichierSelectionne($event)" accept=".xlsx, .xls"
                title="{{ 'USERS_MANAGEMENT.SELECT_EXCEL_FILE' | translate }}" class="text-sm" />
                <p class="text-xs text-gray-500 mt-1 italic">{{ 'USERS_MANAGEMENT.EXCEL_COLUMNS_REQUIRED' | translate }}
                </p>
              </div>
              @if (utilisateursExcel.length > 0) {
                <div class="overflow-x-auto mt-4 max-h-80 overflow-y-auto">
                  <table class="mat-table-novo divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                      <tr>
                        <th scope="col"
                          class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          {{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}
                        </th>
                        <th scope="col"
                          class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          {{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}
                        </th>
                        <th scope="col"
                          class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          {{ 'USERS_MANAGEMENT.EMAIL' | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="mat-table-novo divide-y divide-gray-200">
                      @for (user of utilisateursExcel; track user) {
                        <tr>
                          <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">{{user.prenom}}</td>
                          <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">{{user.nom}}</td>
                          <td class="px-4 py-2 whitespace-nowrap text-xs text-gray-900">{{user.courriel}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </div>
          }

          @if (methodeCreation === 'manual') {
            <div class="mb-4">
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}</span>
                  <input class="w-full p-2 border rounded dark:text-gray-800"
                    placeholder="{{ 'USERS_MANAGEMENT.FIRST_NAME' | translate }}"
                    [(ngModel)]="utilisateurManuel.prenom">
                  </div>
                  <div>
                    <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}</span>
                    <input class="w-full p-2 border rounded dark:text-gray-800"
                      placeholder="{{ 'USERS_MANAGEMENT.LAST_NAME' | translate }}"
                      [(ngModel)]="utilisateurManuel.nom">
                    </div>
                  </div>
                  <div class="mt-4">
                    <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.EMAIL' | translate }}</span>
                    <input type="email" class="w-full p-2 border rounded dark:text-gray-800"
                      placeholder="{{ 'USERS_MANAGEMENT.EMAIL' | translate }}" [(ngModel)]="utilisateurManuel.courriel">
                    </div>
                  </div>
                }

                <div class="flex justify-end mt-4">
                  <button (click)="onAnnuler()" type="button" class="btn-secondary-novo">
                    {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
                  </button>
                  <button (click)="onConfirmer()" type="submit"
                    class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed"
                    [disabled]="boutonCreerDesactive() || chargementEnCours">
                    @if (!chargementEnCours) {
                      <span>{{ 'USERS_MANAGEMENT.CREATE' | translate }}</span>
                    }
                    @if (chargementEnCours) {
                      <mat-spinner [diameter]="24" [color]="'accent'"></mat-spinner>
                    }
                  </button>
                </div>
              </div>
            </div>